import React from 'react';
import T from 'prop-types';

const Screenshots = ({
  appName,
  screenshotUrls,
  screenshotCDNs,
}) => {
  const screenshots = screenshotCDNs.length ? screenshotCDNs : screenshotUrls;

  return (
    <div className="widget-container about-page-screenshots">
      <h2 className="widget-title">Screenshots</h2>

      <div className="screenshots-container show-scrollbar">
        <div className="screenshots-container-inner">
          {screenshots.map((screenshotUrl, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={i} className="screenshots-item">
              <img src={screenshotUrl} alt={`${appName} screenshot ${i + 1}`} loading="lazy" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

Screenshots.propTypes = {
  appName: T.string.isRequired,
  screenshotUrls: T.arrayOf(T.string).isRequired,
  screenshotCDNs: T.arrayOf((T.string)),
};

export default Screenshots;
